import { useDisclosure } from "@chakra-ui/react";
import React, { useState } from "react";
import { BsPencil } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { MdOutlineDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { DeleteBookingModal } from "../Modals/DeleteBookingModal";
import getBookingFormattedDate from "../../Config/Booking";
import { MdCancel } from "react-icons/md";
import { CancelBookingModal } from "../Modals/CancelBookingModal";

export const SingleBookingRow = ({ props, func, id }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    booking_id,
    lead_information: { first_name, last_name },
    expert_information: { full_name },
    booking_date,
    booking_type,
    booking_status,
  } = props;
  const navigate = useNavigate();
  const [modal, setModal] = useState("");
  return (
    <tr>
      <td>
        <div
          className="edit-icon"
          onClick={() => navigate(`/bookings/edit/${booking_id}`)}
        >
          <BsPencil />
        </div>
      </td>
      <td>{booking_id}</td>
      <td>
        {first_name} {last_name}
      </td>
      <td>{full_name}</td>
      <td>{getBookingFormattedDate(booking_date)}</td>
      <td>{booking_type}</td>
      <td> {booking_status} </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/bookings/view/${booking_id}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="cancelButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Cancel">
            <MdCancel
              className="cancelButton pointer"
              onClick={() => {
                setModal("cancelmodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>

      {modal === "deletemodal" && (
        <DeleteBookingModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={booking_id}
        />
      )}
      {modal === "cancelmodal" && (
        <CancelBookingModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={booking_id}
        />
      )}
      {/* AddCommentModal */}
    </tr>
  );
};
